import { CORRECT_ANSWER, CORRECT_ANSWERS, CorrectAnswerNode, CorrectAnswersNode } from './types';

export const createCorrectAnswers = ({
  label = '',
  parentNodeType = undefined,
  children = [createCorrectAnswer()],
  hideGuideline = false,
  withBackground = false,
}): CorrectAnswersNode => ({
  type: CORRECT_ANSWERS,
  parentNodeType,
  label,
  children,
  hideGuideline,
  withBackground,
});

interface CreateCorrectAnswerParams {
  placeholder?: string;
  forId?: string;
  showOrder?: boolean;
  correctAnswer?: string;
  answerType?: 'dropdown' | 'text';

  parentNodeType?: string;
  dropdownNodeType?: string;
}

export const createCorrectAnswer = ({
  placeholder = 'Điền đáp án',
  forId = undefined,
  showOrder = true,
  correctAnswer = '',
  answerType = 'text',

  // answerType === 'dropdown'
  parentNodeType = undefined,
  dropdownNodeType = undefined,
}: CreateCorrectAnswerParams = {}): CorrectAnswerNode => ({
  type: CORRECT_ANSWER,
  showOrder,
  placeholder,
  correctAnswer,
  forId,
  answerType,
  parentNodeType,
  dropdownNodeType,
  children: [{ text: '' }],
});
